import type { SxProps, Theme } from "@mui/material";
import {
  type GridColDef,
  type GridColumnHeaderParams,
  type GridRenderCellParams,
  type GridRowId,
} from "@mui/x-data-grid-premium";
import SelectAllHeaderCheckbox from "./SelectAllHeaderCheckbox.tsx";
import SelectionCheckboxCell from "./SelectionCheckboxCell.tsx";

export const PAGE_SIZE = 1000;
// A condition value of null means "No Value"; the server gives that row this id because null cannot be a grid row id.
const NO_VALUE_ROW_ID = "__noValue";

export const gridCheckboxColDef: Partial<GridColDef> = {
  renderHeader: (params: GridColumnHeaderParams) => <SelectAllHeaderCheckbox {...params} />,
  renderCell: (params: GridRenderCellParams) => <SelectionCheckboxCell params={params} />,
};

// Select-all writes the whole page straight to the selection, which disableMultipleRowSelection cannot stop.
export const singleSelectGridCheckboxColDef: Partial<GridColDef> = {
  renderHeader: () => null,
  renderCell: (params: GridRenderCellParams) => <SelectionCheckboxCell params={params} />,
};

export const toRowId = (value: string | null): GridRowId => value ?? NO_VALUE_ROW_ID;

export const toConditionValue = (id: GridRowId): string | null => (id === NO_VALUE_ROW_ID ? null : String(id));

export const textFilterGridSx: SxProps<Theme> = (theme) => ({
  "--DataGrid-rowBorderColor": theme.palette.divider,
  border: "1px solid " + theme.palette.divider,
  ".MuiDataGrid-columnHeaders": { borderBottom: "none" },
  ".MuiDataGrid-cell:focus-within": { outline: "unset" },
  ".MuiDataGrid-columnHeader:focus-within": { outline: "unset" },
  ".MuiDataGrid-row": {
    ".MuiDataGrid-cell": {
      borderTop: "none",
      ".MuiDataGrid-groupingCriteriaCell": {
        fontWeight: "500",
        ".MuiDataGrid-groupingCriteriaCellToggle": { marginRight: "4px" },
      },
    },
  },
  ".MuiButtonBase-root.MuiCheckbox-root": { p: 0.75 },
  ".MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--borderTop": { border: "none" },
});

export const busySx: SxProps<Theme> = {
  "&:has(.MuiDataGrid-overlayWrapper) .MuiDataGrid-main": { pointerEvents: "none" },
};
